import { useEffect } from 'react';

const SELECTOR = '[data-reveal]';
const VISIBLE_CLASS = 'in-view';

/**
 * Adds an `in-view` class to elements with `data-reveal` when they enter the
 * viewport. Uses a single shared IntersectionObserver. Safe in environments
 * without IntersectionObserver (just makes everything visible).
 */
export function useReveal(): void {
  useEffect(() => {
    const els = document.querySelectorAll<HTMLElement>(SELECTOR);

    if (typeof IntersectionObserver === 'undefined') {
      els.forEach((el) => el.classList.add(VISIBLE_CLASS));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(VISIBLE_CLASS);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
    );

    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}
